/**
 * Convierte la respuesta del API de bancos (workflow) al formato de items de v-select.
 * @param {Array<{ nombreBanco?: string, rucBanco?: string, emailBanco?: string, indActivo?: boolean }>} rows
 * @returns {Array<{ text: string, value: string, email: string }>}
 */
export function mapWorkflowBanksToSelectItems (rows) {
  if (!Array.isArray(rows)) {
    return [{ text: 'OTROS', value: 'otros', email: '' }]
  }

  const mapped = rows
    .filter((r) => r && r.indActivo === true)
    .map((r) => ({
      text: String(r.nombreBanco || '').trim(),
      value: String(r.rucBanco || '').trim(),
      email: String(r.emailBanco || '').trim()
    }))
    .filter((r) => r.value.length > 0)

  mapped.push({ text: 'OTROS', value: 'otros', email: '' })
  return mapped
}



// WEBPACK FOOTER //
// ./src/utils/workflow-banks.js